import artifact from '$houdini/artifacts/GenerateCrystalReport'
import { MutationStore } from '../runtime/stores/mutation'

export class GenerateCrystalReportStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
